import React from "react";
import { Typography } from "@mui/material";
import { brand } from "../theme";
import PageLayout from "../components/PageLayout";
import ResponsiveImage from "../components/ResponsiveImage";
import ContactInfo from "../components/ContactInfo";

const FULL_WIDTH_SIZES = "(max-width: 1200px) 100vw, 1200px";
const imageSx = { borderRadius: 2, boxShadow: 3, mb: 4 };

const Wood: React.FC = () => {
    return (
        <PageLayout title="Holzhandel">
            <Typography variant="body1" color="inherit" sx={{ textAlign: "justify", mb: 4 }}>
                Ebenso ein neueres, aber wichtiges Angebot von uns ist der Holzhandel. Da wir hauptsächlich mit
                Massivholz arbeiten, haben wir beschlossen, uns ein eigenes Holzlager aufzubauen. Von diesem Lager
                beziehen wir nicht nur selbst Holz, sondern verkaufen auch davon. Uns ist es wichtig, unser Angebot
                möglichst vielseitig zu gestalten. Deshalb beobachtet Nicolas regelmässig den Holzmarkt und
                organisiert Stämme. Mittlerweile umfasst unser Holzlager ungefähr 12 verschiedene Holzarten. Wir
                kaufen die Stämme und führen sie dann alle zusammen vom Wald zu uns.
            </Typography>

            <ResponsiveImage src="/img/transport_big.jpg" alt="Transport von Holz" sizes={FULL_WIDTH_SIZES} sx={imageSx} />

            <Typography variant="h5" gutterBottom sx={{ color: brand.orange, mt: 6 }}>
                Sägen
            </Typography>

            <Typography variant="body1" color="inherit" sx={{ textAlign: "justify", mb: 4 }}>
                Unser gekauftes Rundholz bringen wir immer zur Christen-Baltenswil AG. Dies ist die Sägerei, die uns
                das Holz zu Brettern sägt.
            </Typography>

            <ResponsiveImage src="/img/sawmill.jpg" alt="Sägerei" sizes={FULL_WIDTH_SIZES} sx={imageSx} />

            <Typography variant="h5" gutterBottom sx={{ color: brand.orange, mt: 6 }}>
                Holzlager
            </Typography>

            <Typography variant="body1" color="inherit" sx={{ textAlign: "justify", mb: 4 }}>
                Die fertig gesägten Bretter werden nun wieder zu uns in unser Holzlager transportiert und dort
                eingelagert. Dort trocknet das Holz so lange, bis es genug trocken ist für die Weiterverarbeitung
                und den Verkauf. Da wir für unsere Kunden nur das Beste wollen, achten wir besonders auf die
                Herkunft des Holzes. Wir arbeiten viel mit Brüttemer Holz, das in Brütten gewachsen ist. Ebenfalls
                kommt ein grosser Teil unseres Holzes aus Kloten und sonst aus der Region. Bei Interesse ist eine
                Besichtigung möglich!
            </Typography>

            <Typography variant="h6" gutterBottom sx={{ color: brand.orange, mt: 6 }}>
                Melden Sie sich unter:
            </Typography>

            <ContactInfo />
        </PageLayout>
    );
};

export default Wood;
